/* global angular, $ */
angular.module('ua5App')
    .directive('linkify', ['$timeout', function($timeout) {
        return {
            restrict: 'A',
            link: function($scope, element) {
                $timeout(function() {
                    $(element).linkify({
                        target: '_blank'
                    });
                });
            }
        };
    }
]);
